// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";

var similarResultsContainer = Curry._1(BsCss.style, {
      hd: BsCss.selector("> h3", {
            hd: BsCss.marginLeft(BsCss.rem(0.8)),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var rootContainerWall = "container mx-auto p-0";

var cardsContainer = "flex mt-4 flex-wrap";

var title = "text-2xl sm:text-32px leading-8 font-semibold pt-4 mx-4 pb-2 sm:pb-3";

var description = "text-base mx-4 text-gray-600";

var aboutGrid = "flex flex-wrap pt-10 -mx-6 text-sm text-gray-600 mx-auto";

export {
  rootContainerWall ,
  cardsContainer ,
  title ,
  description ,
  aboutGrid ,
  similarResultsContainer ,
}
/* similarResultsContainer Not a pure module */
